import { Box, HStack, Select, Stack } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { AiFillCloseCircle } from 'react-icons/ai'
import { CgProductHunt } from 'react-icons/cg'
import { SiQuantcast } from 'react-icons/si'
import { IoMdPricetags } from 'react-icons/io'
import Input from './Input'
import { FaUserAlt, FaUserFriends } from 'react-icons/fa'
import { GetAllProductShelf, GetAllProductShelfWithoutDA, GetAllStores } from '../Utils/ApiCalls'
import { isEmergency } from '../Authetication'

export default function ScnCard({ Payload, setPayload, oldItem = [], data, i, }) {
    let itemToUpdate = oldItem;
    const [Data, setData] = useState([]);
    const [DataStore, setDataStore] = useState([]);
    const [Emergency, setEmergency] = useState(isEmergency());

    const [FilterStore, setFilterStore] = useState("");


    const handleShelfId = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj, index) => index == i);

        // console.log("idd", objIndex, itemToUpdate[objIndex]);

        itemToUpdate[objIndex].shelfid = e.target.value

        setPayload({ ...Payload, scn: itemToUpdate });

    }
    const handleStore = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj, index) => index == i);
        
        
        itemToUpdate[objIndex].store = e.target.value
        
        console.log("itemToUpdate",itemToUpdate[0].store)
        setFilterStore(itemToUpdate[0].store)
        setPayload({ ...Payload, scn: itemToUpdate });
    }
    const handleQtyReturned = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj, index) => index == i);

        itemToUpdate[objIndex].qtyreturned = e.target.value

        setPayload({ ...Payload, scn: itemToUpdate });
    }
    const handlePrice = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj, index) => index == i);

        itemToUpdate[objIndex].price = e.target.value

        setPayload({ ...Payload, scn: itemToUpdate });
    }
    const handleReturneeDept = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj, index) => index == i);

        itemToUpdate[objIndex].returneedepartment = e.target.value

        setPayload({ ...Payload, scn: itemToUpdate });
    }
    const handleReturnby = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj, index) => index == i);

        itemToUpdate[objIndex].returnby = e.target.value

        setPayload({ ...Payload, scn: itemToUpdate });
    }

    const removeItem = () => {
        let newItem = oldItem.filter((obj, index) => (
            index !== i
        ))

        setPayload({ ...Payload, scn: newItem })
    }


    const GetAllShelf = async () => {
        let result = await GetAllProductShelfWithoutDA()

        console.log("result shelf", result);

        if (result.status == true) {
            isEmergency() ? (
                setData(result.queryresult.productshelfdetails.filter(item => item.store == FilterStore ))

            ):(
                setData(result.queryresult.productshelfdetails)

            )
        }
    }

    const AllStores = async () => {
        let result = await GetAllStores()
        console.log("result store", result);

        if (result.status === true) {
            setDataStore(result.queryresult)
        }
    }




    useEffect(() => {
        GetAllShelf()
        AllStores()

    }, [FilterStore]);

    return (
        <Stack spacing={"15px"}>
            <Box cursor={"pointer"} onClick={removeItem} display={i == 0 ? "none" : "flex"} justifyContent="flex-end"><AiFillCloseCircle /></Box>

            <HStack>
{
    isEmergency() && (
        <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select Store' fontWeight={"400"} fontSize={data.store != "" ? "16px" : "12px"} id='store' value={data.store} onChange={handleStore}>
                    {
                        DataStore.filter(item => item.value != 1 ).map((item, i) => (

                            <option value={`${item.value}`} >{item.name}</option>
                        ))


                    }

                </Select>
    )
}
              
                <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Select shelfId' fontWeight={"400"} fontSize={data.shelfid != "" ? "16px" : "12px"} id='shelfid' value={data.shelfid} onChange={handleShelfId}>
                    {
                        Data.map((item, i) => (

                            <option value={`${item._id}`} >{item.productname}</option>
                        ))


                    }

                </Select>

            </HStack>
            <HStack>
                <Input leftIcon={<IoMdPricetags />} iconColor="black" labelBg='#fff' label='Price' id="price" type='number' value={data.price} val={data.price != "" ? true : false} onChange={handlePrice} />
                <Input leftIcon={<FaUserFriends />} iconColor="black" labelBg='#fff' label='Returnee department' id="returneedepartment" type='text' value={data.returneedepartment} val={data.returneedepartment != "" ? true : false} onChange={handleReturneeDept} />

            </HStack>
            
                    <HStack>

                        <Input leftIcon={<FaUserAlt />} iconColor="black" labelBg='#fff' label='Return by' id="returnby" type='text' value={data.returnby} val={data.returnby != "" ? true : false} onChange={handleReturnby} />
                        <Input leftIcon={<SiQuantcast />} iconColor="black" labelBg='#fff' label='Quantity Returned' id="qtyreturned" type='number' value={data.qtyreturned} val={data.qtyreturned != "" ? true : false} onChange={handleQtyReturned} />


                    </HStack>
           



        </Stack>
    )
}
